import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';

const Taxes = (props) => {
  const { cartOrOrder } = props;

  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { taxes } = cartOrOrder;

  if (!taxes) {
    return null;
  }
  const taxNotInclude = taxes.filter((tax) => tax.isIncludedInPrice === false);
  return (
    <>
      {taxNotInclude.map((tax) => (
        <div className="c7-order-summary__item" key={tax.id}>
          <div className="c7-order-summary__title">{tax.title}</div>
          <div className="c7-order-summary__value">
            {currencyFormat(tax.price, currency)}
          </div>
        </div>
      ))}
    </>
  );
};

export default Taxes;
